export default "__VITE_ASSET__CRyH297Q__"